import useSWR from 'swr'

import { FetchError } from '../fetchError'
import { FetchResponse } from '../fetchResponse'
import { FetchResult } from '../fetchResult'
import { fetchJson } from '../fetchers'
import {
  DeliveryForecastProcessStep,
  EmailSettings,
  OrderProcessStep,
} from './models'

export function useAllEmailSettings(): FetchResult<EmailSettings> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EmailSettings>,
    FetchError
  >(`/Settings/Email`, fetchJson<EmailSettings>)

  const result: FetchResult<EmailSettings> = {
    data: data?.body,
    error,
    isLoading,
    mutate,
  }

  return result
}

export function useOrderProcessStep(): FetchResult<OrderProcessStep> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<OrderProcessStep>,
    FetchError
  >(`/Settings/ProcessStep/Order`, fetchJson<OrderProcessStep>)

  const result: FetchResult<OrderProcessStep> = {
    data: data?.body,
    error,
    isLoading,
    mutate,
  }

  return result
}

export function useDeliveryForecastProcessStep(): FetchResult<DeliveryForecastProcessStep> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastProcessStep>,
    FetchError
  >(
    `/Settings/ProcessStep/DeliveryForecast`,
    fetchJson<DeliveryForecastProcessStep>,
  )

  const result: FetchResult<DeliveryForecastProcessStep> = {
    data: data?.body,
    error,
    isLoading,
    mutate,
  }

  return result
}
